import { ThemeConfig } from "./theme";

export const bellaTchauTheme: ThemeConfig = {
  primaryColor: "#DF8925",
  secondaryColor: "#FFFFFF",
};
